// Load all v1 assisting blocks first, then override with v2 changes

import AssistingBlocksV1 from "../../v1/assistingBlocks";
// Import only the blocks that changed in v2
// import RestCoreV2 from "./RestCore";  // Example of overwriting the v1 RestCore registration
import RestCoreV2 from "./RestCore";
import RestParamsV2 from "./RestParams";

const AssistingBlocksV2 = function(props) {
    // Load all v1 assisting blocks first
    AssistingBlocksV1(props);
    
    // Override with v2 changes (example of overwriting the v1 RestCore registration)
    // RestCoreV2(props);  // This is an example for overwrites the v1 RestCore registration
    RestParamsV2();
    RestCoreV2(props);
    
    return null;
};

export default AssistingBlocksV2;
